import html from "html-literal";

export default () => html`
  <main class="about-main">
    <div class="about-project">
      <h2>About Project</h2>
      <p>
        RiskRadar is a cutting-edge application designed to enhance
        cybersecurity for businesses by providing a comprehensive view of their
        digital threat landscape. In today's interconnected world, the
        visibility of online threats is crucial for protecting sensitive data
        and maintaining business continuity. Our application leverages advanced
        technologies, including the FullHunt IP Lookup API, to identify
        potential vulnerabilities and exposed documents on the web, offering
        businesses an essential tool in their cybersecurity arsenal. By
        utilizing RiskRadar, companies can proactively manage their digital
        risk, ensuring better protection against cyber threats.
      </p>
    </div>
    <div class="about-me">
      <h2>About Me</h2>
      <p>
        I am a cybersecurity enthusiast with a passion for protecting digital
        assets. My expertise lies in understanding the complex nature of online
        threats and devising strategic solutions to counter them. My experience
        in cybersecurity analysis and commitment to staying abreast of the
        latest trends in digital security have equipped me with the skills
        necessary to develop RiskRadar. This project is a culmination of my
        dedication to making the digital world safer for businesses of all
        sizes.
      </p>
    </div>
    <div class="next-steps">
      <h2>Future Steps</h2>
      <ul>
        <li>
          <strong>Develop a Cybersecurity Blog:</strong> Launch a blog dedicated
          to helping small businesses understand and navigate their cyber threat
          landscape.
        </li>
        <li>
          <strong>Expand Tool Capabilities:</strong> Integrate additional
          features and diverse APIs to enhance the user experience and provide
          more comprehensive security analysis.
        </li>
        <li>
          <strong>Machine Learning Integration:</strong> Explore the use of
          machine learning algorithms for predictive threat analysis, further
          strengthening proactive defense strategies.
        </li>
        <li>
          <strong>Community Engagement:</strong> Foster a community for users to
          share insights, experiences, and best practices in cybersecurity.
        </li>
        <li>
          <strong>Continuous Updates:</strong> Regularly update the application
          with the latest cybersecurity trends and threat intelligence.
        </li>
      </ul>
    </div>
  </main>
`;
